import React from 'react';

const ServiceComparison = () => {
  const comparisonData = {
    features: [
      { name: 'Basic Support', starter: true, professional: true, enterprise: true },
      { name: 'Responsive Design', starter: true, professional: true, enterprise: true },
      { name: 'SEO Optimization', starter: false, professional: true, enterprise: true },
      { name: 'Analytics Setup', starter: false, professional: true, enterprise: true },
      { name: 'Performance Tuning', starter: false, professional: true, enterprise: true },
      { name: 'AI Integration', starter: false, professional: false, enterprise: true },
      { name: 'Custom Integrations', starter: false, professional: false, enterprise: true },
      { name: 'Dedicated Support', starter: false, professional: false, enterprise: true },
      { name: 'Post-Launch Training', starter: false, professional: false, enterprise: true }
    ]
  };

  return (
    <section id="service-comparison">
      <div className="section-header">
        <h2 className="section-title">Service Comparison</h2>
        <p className="section-subtitle">Choose the perfect plan for your needs</p>
      </div>
      <div className="comparison-table-container">
        <table className="comparison-table fade-in">
          <thead>
            <tr>
              <th>Feature</th>
              <th className="starter-col">Starter</th>
              <th className="professional-col">Professional</th>
              <th className="enterprise-col">Enterprise</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.features.map((feature, index) => (
              <tr key={index}>
                <td className="feature-name">{feature.name}</td>
                <td className="starter-col">{feature.starter ? '✓' : '—'}</td>
                <td className="professional-col">{feature.professional ? '✓' : '—'}</td>
                <td className="enterprise-col">{feature.enterprise ? '✓' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ServiceComparison;
